import { Injectable } from '@angular/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { ToastController } from '@ionic/angular';
import { SwUpdate } from '@angular/service-worker';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  constructor(
    private toastCtrl: ToastController,
    private swUpdate: SwUpdate,
  ) { }


  updateAvailable = false;
  capgoUpdateAvailable = false;

  async setChannel(channel: 'production' | 'dev') {
    try {
      const result = await CapacitorUpdater.setChannel({ channel });

      if (result.message == 'Rate limit exceeded') {
        return undefined
      }

      console.log('Channel set to:', channel);
      localStorage.setItem('capgo_channel', channel);

      return result;
    } catch (error) {
      console.error('Error setting channel:', error);
    }


  }

  async getChannel() {

    let currentCh = localStorage.getItem('capgo_channel')

    if (!currentCh) currentCh = PROD_CH

    return { channel: currentCh };


    /// disabilitato perchè ottengo rate limiting...
    /*
    console.log('getChannel');
    try {
      const result = await CapacitorUpdater.getChannel();
      console.log('Current channel:', result);
      return result;
    } catch (error) {
      console.error('Error getting channel:', error);
    }*/
  }

  async checkVersion(verbose = false) {

    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(async event => {

        if (event.type === 'VERSION_DETECTED') {
          this.showUpdateToast();
        }

        if (event.type === 'VERSION_READY') {
          //setTimeout(() => document.location.reload(), 100);
          this.updateAvailable = true;
        }
        if (event.type === 'NO_NEW_VERSION_DETECTED' && verbose) {
          const toast = await this.toastCtrl.create({
            message: 'Il sistema è aggiornato',
            duration: 1500,
            position: 'bottom',
            color: 'success',
          });
          await toast.present();
        }
      });
    }

  }

  async showUpdateToast() {
    const toast = await this.toastCtrl.create({
      message: 'Nuova versione disponibile, aggiornamento in corso...',
      duration: 1500,
      position: 'bottom',
      color: 'primary',
    });
    await toast.present();
  }


  isChecking = false
  downloaded
  checkUpdateCapgo(verbose = false) {
    console.log('checkUpdateCapgo1')

    this.isChecking = true

    CapacitorUpdater.getLatest().then(async (update) => {
      console.log('[CAPGO] update check result:', update);
      const currentBundle = await CapacitorUpdater.current()
      if (update && update.version !== currentBundle.bundle.version) {

        CapacitorUpdater.download(update as any).then((downloaded) => {
          console.log('Downloaded update:', downloaded);

          this.isChecking = false;
          //this.downloaded = downloaded;
        })

        await CapacitorUpdater.removeAllListeners();

        CapacitorUpdater.addListener('downloadComplete', (downloaded) => {

          console.log('downloaded1: ', downloaded);
          this.downloaded = downloaded;
          this.capgoUpdateAvailable = true;
        });

        //alert('Aggiornamento disponibile: ' + update.version);
      }
    }).catch((error) => {

      this.isChecking = false;
      if (verbose)

        this.toastCtrl.create({
          message: error.message == 'no_new_version_available' ? 'Il sistema è aggiornato' : 'Errore durante il controllo degli aggiornamenti',
          duration: 1500,
          color: error.message == 'no_new_version_available' ? 'success' : 'danger',
        }).then(toast => toast.present());

      console.error('[CAPGO] Error checking for update:', error);
    });

  }


  async reloadApp() {

    if (this.capgoUpdateAvailable && this.downloaded?.bundle?.id) {


      await CapacitorUpdater.set({ id: this.downloaded.bundle.id });

      this.updateAvailable = false;
      this.capgoUpdateAvailable = false;


    } else {

      setTimeout(() => {
        document.location.reload();
      }, 50);

    }



  }

}


export const DEV_CH = 'dev'
export const PROD_CH = 'production'